import React from 'react';

export default {
  not_found: () => (
    <div>
      <p className="error">An error occurred</p>
    </div>
  ),
};